import { arrayOf, func } from "prop-types";
import MinusListItem from "./MinusListItem";
import { List } from "./styled";
import { itemType } from "./types";

const MinusList = ({ items, onItemRemove }) => {
  if (!items?.length) return null;

  const listItems = items.map((item, index) => (
    <MinusListItem
      key={`item-${index}`}
      item={item}
      onItemRemove={onItemRemove}
    />
  ));

  return <List>{listItems}</List>;
};

MinusList.propTypes = {
  onItemRemove: func.isRequired,
  items: arrayOf(itemType),
};

export default MinusList;
